import * as React from 'react';

import PropTypes from 'prop-types';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Checkbox as MuiCheckbox } from '@mui/material';
import CheckBoxOutlineBlankSharpIcon from '@mui/icons-material/CheckBoxOutlineBlankSharp';
import { ReactComponent as CheckIcon } from 'assets/icons/svgs/icon-tick-green.svg';

import './Checkbox.scss';

export const Checkbox = (props) => {
  const { label, value, disabled, isChecked = false, checkboxChangeHandler, muiProps } = props;
  const [checked, setChecked] = React.useState(isChecked);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    checkboxChangeHandler(event);
  };

  return (
    <div className="checkbox">
      <FormGroup>
        <FormControlLabel
          control={
            <MuiCheckbox
              checked={checked}
              onChange={handleChange}
              inputProps={{ 'aria-label': 'controlled' }}
              disabled={disabled}
              data-testid="checkbox"
              color="success"
              disableRipple
              size="medium"
              className="checkbox__input"
              value={value}
              icon={
                <CheckBoxOutlineBlankSharpIcon className="checkbox__icon checkbox__icon--normal" />
              }
              checkedIcon={<CheckIcon className="checkbox__icon checkbox__icon--tick" />}
            />
          }
          label={label}
          data-testid="form-control-label"
          {...muiProps}
        />
      </FormGroup>
    </div>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  isChecked: PropTypes.bool,
  checkboxChangeHandler: PropTypes.func,
  muiProps: PropTypes.object,
};
